/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Library } from '../../Library';
import { AaiHeaderItem } from '../../asyncapi/models/AaiHeaderItem';
import { AaiOperation } from '../../asyncapi/models/AaiOperation';
import { Aai20NodeFactory } from '../../asyncapi/v2/models/Aai20NodeFactory';
import { AbstractCommand } from '../AbstractCommand';
import { ModelUtils } from '../util/ModelUtils';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { Document } from '../../core/models/Document';
import { NodePath } from '../../core/models/NodePath';
import { Node } from '../../core/models/Node';
import { AaiMessage } from '../../asyncapi/models/AaiMessage';

/**
 * A command used to change the $ref inside an AsyncAPI message headers.
 * @author laurent.broudoux@gmail.com
 * @deprecated Use {@link ChangePropertyCommand} instead.
 * @extends AbstractCommand
 * @class
 */
export class ChangeHeadersRefCommand_Aai20 extends AbstractCommand {
    public _operationPath : NodePath;

    public _headersRef : string;

    public _oldHeadersRef : string;

    public _changed : boolean;

    public constructor(headersRef? : any, operationNode? : any) {
        if(((typeof headersRef === 'string') || headersRef === null) && ((operationNode != null && operationNode instanceof <any>AaiOperation) || operationNode === null)) {
            let __args = arguments;
            super();
            if(this._operationPath===undefined) this._operationPath = null;
            if(this._headersRef===undefined) this._headersRef = null;
            if(this._changed===undefined) this._changed = false;
            this._oldHeadersRef = null;
            if(this._operationPath===undefined) this._operationPath = null;
            if(this._headersRef===undefined) this._headersRef = null;
            if(this._changed===undefined) this._changed = false;
            (() => {
                this._operationPath = Library.createNodePath(operationNode);
                this._headersRef = headersRef;
            })();
        } else if(headersRef === undefined && operationNode === undefined) {
            let __args = arguments;
            super();
            if(this._operationPath===undefined) this._operationPath = null;
            if(this._headersRef===undefined) this._headersRef = null;
            if(this._changed===undefined) this._changed = false;
            this._oldHeadersRef = null;
            if(this._operationPath===undefined) this._operationPath = null;
            if(this._headersRef===undefined) this._headersRef = null;
            if(this._changed===undefined) this._changed = false;
        } else throw new Error('invalid overload');
    }

    /**
     * 
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[ChangeHeadersRefCommand_Aai20] Executing.");
        let operation : AaiOperation = <AaiOperation>this._operationPath.resolve(document);
        this._changed = false;
        if(this.isNullOrUndefined(operation) || this.isNullOrUndefined(operation.message) || !this.isValidRef(this._headersRef)) {
            return;
        }
        let headerItem : AaiHeaderItem = operation.message.headers;
        if(headerItem == null) {
            let nodeFactory : Aai20NodeFactory = new Aai20NodeFactory();
            headerItem = nodeFactory.createHeaderItem(operation.message);
            operation.message.headers = headerItem;
        }
        if(headerItem.$ref != null) {
            this._oldHeadersRef = headerItem.$ref;
        }
        headerItem.$ref = this._headersRef;
        this._changed = true;
    }

    /**
     * 
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[ChangeHeadersRefCommand_Aai20] Reverting.");
        let operation : AaiOperation = <AaiOperation>this._operationPath.resolve(document);
        if(!this._changed || this.isNullOrUndefined(operation) || this.isNullOrUndefined(operation.message)) {
            return;
        }
        let headerItem : AaiHeaderItem = operation.message.headers;
        if(this._oldHeadersRef != null) {
            headerItem.$ref = this._oldHeadersRef;
        } else {
            headerItem.$ref = null;
        }
    }

    /*private*/ isValidRef(refCandidate : string) : boolean {
        return ModelUtils.isDefined(refCandidate) && /* startsWith */((str, searchString, position = 0) => str.substr(position, searchString.length) === searchString)(refCandidate, "#/");
    }
}
ChangeHeadersRefCommand_Aai20["__class"] = "io.apicurio.datamodels.cmd.commands.ChangeHeadersRefCommand_Aai20";
ChangeHeadersRefCommand_Aai20["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




